module.exports = {
    getLocal: function(){
        return localStorage.getItem('lang') || 'en-us';
    },
    setLocal: function(lang){
        localStorage.setItem('lang', lang);
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/services/appService.js
 ** module id = 8
 ** module chunks = 0
 **/